import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../config/api.config';

/**
 * Fetches master products list for a client from backend API
 * @param {string} customerId - Customer ID for filtering
 * @returns {Promise<Object>} Response containing products array with pending proposal metadata and option sets
 */
export const fetchMasterProductsList = async (customerId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await axios.get(
      `${API_BASE_URL}/products/master-list?clientId=${customerId}`,
      {
        headers: createAuthHeader(token)
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error fetching master products list:', error);
    throw error;
  }
};

/**
 * Registers a pending proposal for a product master data change
 * @param {string} customerId - Customer ID for filtering
 * @param {number} productId - Product identifier
 * @param {{ productCategory?: string, subcategory?: string, laneType?: string }} payload - Proposed values
 * @returns {Promise<Object>} Response containing the stored proposal metadata
 */
export const submitProductProposal = async (customerId, productId, payload) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await axios.post(
      `${API_BASE_URL}/products/${productId}/proposals?clientId=${customerId}`,
      payload,
      {
        headers: createAuthHeader(token)
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error submitting product proposal:', error);
    throw error;
  }
};
